import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import LikedIcon from "@mui/icons-material/Favorite";
import UnlikedIcon from "@mui/icons-material/FavoriteBorder";
import moment from "moment";
import { withStyles } from "@mui/styles";

import config from "../config";

const styles = {
  root: {
    position: "absolute",
    top: 30,
    right: 30,
    zIndex: 1
  },
  counter: {
    display: "flex",
    alignItems: "center"
  }
};

class Likes extends React.Component {
  state = {
    timeStamp: moment(),
    numLikes: null,
    updatingLikes: false,
    liked: false,
    likeId: null
  };

  componentDidMount() {
    fetch(config.like_api_endpoint, {
      headers: {
        "content-type": "application/json",
        "x-apikey": config.like_api_key,
        "cache-control": "no-cache"
      }
    })
      .then(response => response.json())
      .then(response => {
        if (Array.isArray(response)) {
          this.setState({ numLikes: response.length });
        } else {
          console.log("Failed to fetch likes.");
        }
      })
      .catch(error => console.log("Unable to connect to API.", error));
  }

  updateLikes = () => {
    const { timeStamp, numLikes, liked } = this.state;

    this.setState({ updatingLikes: true });

    if (!liked) {
      fetch(config.like_api_endpoint, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "x-apikey": config.like_api_key,
          "cache-control": "no-cache"
        },
        body: JSON.stringify({ timeStamp })
      })
        .then(response => response.json())
        .then(response => {
          if (response._id) {
            this.setState({
              numLikes: numLikes + 1,
              updatingLikes: false,
              liked: true,
              likeId: response._id
            });
          } else {
            console.log("Failed to add like.");
          }
        })
        .catch(error => console.log("Unable to connect to API.", error));
    } else {
      fetch(`${config.like_api_endpoint}/${this.state.likeId}`, {
        method: "DELETE",
        headers: {
          "content-type": "application/json",
          "x-apikey": config.like_api_key,
          "cache-control": "no-cache"
        }
      })
        .then(response => response.json())
        .then(({ result }) => {
          if (Array.isArray(result) && result.length) {
            this.setState({
              numLikes: numLikes - 1,
              updatingLikes: false,
              liked: false,
              likeId: null
            });
          } else {
            console.log("Failed to remove like.");
          }
        })
        .catch(error => console.log("Unable to connect to API.", error));
    }
  };

  render() {
    const { classes } = this.props;
    const { numLikes, updatingLikes, liked } = this.state;
    return (
      <div className={classes.root}>
        {numLikes !== null ? (
          <div className={classes.counter}>
            {numLikes}
            <IconButton size='small' onClick={this.updateLikes}>
              {updatingLikes ? (
                <CircularProgress color='secondary' size={20} />
              ) : liked ? (
                <LikedIcon color='secondary' fontSize='small' />
              ) : (
                <UnlikedIcon color='secondary' fontSize='small' />
              )}
            </IconButton>
          </div>
        ) : (
          <CircularProgress color='secondary' size={24} />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Likes);
